import { PromotionsState } from './types';

const initialState: PromotionsState = [];

export default initialState;
